import { Component, Injector, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { MediaPictureService } from "../../../services/media-picture.service";

declare var window: any;

@Component({
  selector: 'user-recent-activity-card',
  template: `
    <div class="user-recent-activity-item" [ngClass]="{'-with-picture': !isMobile}">
      <div *ngIf="picture && !isMobile && getPicture(picture) as picture"
          class="user-recent-activity-image" style="background-image: url('{{picture}}')"></div>
      <div class="user-recent-activity-content-container">
        <div class="user-recent-activity-content">

          <p class="user-recent-activity-product eva-3-overline-2">
            <i class="user-recent-activity-icon -eva-3-icon-sm eva-3-icon-{{iconName}}"></i>
            {{productName}}
          </p>
          <h3 class="user-recent-activity-title eva-3-h3" [ngClass]="{'two-lines': !drivers}">{{title}}</h3>
          <div *ngIf="drivers" class="user-recent-activity-details" [ngClass]="{'-with-pipe': iconName!=='cars-ui'}">
            <ng-container *ngFor="let driverText of drivers.level1">
              <span class="user-recent-activity-detail-1">{{driverText}}</span>
            </ng-container>
            <ng-container *ngFor="let driverText of drivers.level2">
              <span class="user-recent-activity-detail-2" [ngClass]="{'-left-padding': drivers.level1?.length}">{{driverText}}</span>
            </ng-container>
          </div>
        </div>
        <div *ngIf="searchLink" class="buttons-container">

          <eva-button *ngIf="plannerLink" class="user-recent-activity-planner-button"
            [options]="{link: plannerLink, target: '_blank', ghost_button: true, type: '-default', link_text: ('userRecentActivity.plannerButtonText' | translate)}"
            [moduleId]="getModuleId()"
            [upaData]="getUpaData(rowPosition, 'PLANNER_BUTTON', plannerLink)">
          </eva-button>
          <eva-button class="user-recent-activity-search-button"
            [options]="{link: searchLink, target: '_blank', type: '-primary', link_text: ('userRecentActivity.searchButtonText' | translate)}"
            [moduleId]="getModuleId()"
            [upaData]="getUpaData(rowPosition, 'SEARCH_BUTTON', searchLink)">
          </eva-button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./user-recent-activity-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserRecentActivityCardComponent extends AbstractComponent {

  @ViewChild("content") content: any;
  private static MODULE_ID = 'UserRecentActivityModule';
  private PICTURE_SIZE = "200x200";

  @Input() uniqueId: string;
  @Input() upaData: any;

  @Input() rowPosition: number;
  @Input() iconName: string;
  @Input() picture: string;
  @Input() productName: string;
  @Input() drivers: {
    level1?: string[];
    level2?: string[];
  };
  @Input() searchLink: string;
  @Input() searchLinkText: string;
  @Input() plannerLink: string;
  @Input() title: string;
  @Input() destinationCode: string;

  @Input() isMobile: boolean;
  @Input() extraInfo: {
    rating?: string;
  };

  constructor(injector: Injector, private mediaPictureService: MediaPictureService) {
    super(injector);
  }

  getModuleId(): string {
    return UserRecentActivityCardComponent.MODULE_ID;
  }

  getPicture(picture: string): string | undefined {
    const urlWithoutHttp = picture.startsWith("https:") ? picture.split("https:")[1] : picture;
    return this.mediaPictureService.getMediaUrl(urlWithoutHttp, this.PICTURE_SIZE);
  }

  clickHandler(position: number) {
    this.upaService.trackClickTopic(this.getUpaData(position));
    window.open(this.searchLink);
  }

  getUpaData(position: number, label?: string, href?: string) {
    return {...this.upaData,
      label: label,
      moduleId: this.getModuleId(),
      moduleIndex: this.upaData.row_number,
      uniqueId: this.uniqueId,
      positionIndex: position,
      href: href || this.searchLink,
      data: {city: this.destinationCode}
    };
  }
}
